import styled, { css } from 'styled-components';
import Alert from 'components/Alert';
import { H6, P } from 'components/Typography';
import { sizes } from 'style';
import { th } from 'style/theme';
import Feedback from 'products/nomad_insurance/components/Feedback';

export const FormWrapper = styled.div`
  position: relative;
  padding: 16px;
  padding-top: 0;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: ${th('colors.confetti')};
`;

export const StyledAlert = styled(Alert)`
  margin-bottom: 12px;
`;

export const StyledInputFieldAlert = styled(Alert)`
  margin-top: 12px;
`;

export const StyledFeedback = styled(Feedback)`
  margin: 16px 0;
`;

export const Paragraph = styled(P)`
  color: inherit;
  margin-bottom: 6px;
`;

export const WarningHeading = styled(H6)`
  margin: 2px 0 8px;
`;

export const StyledInputSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 0 17px 0;
  border-top: 1px solid ${th('colors.confetti')};

  ${({ $hideTopBorder }) =>
    $hideTopBorder &&
    css`
      border-top: none;
    `};

  @media ${sizes.largeDesktop} {
    flex-direction: row;
    justify-content: space-between;
    gap: 24px;
  }
`;

export const InputSectionLabel = styled.div`
  margin-bottom: 4px;
  font-weight: 500;
`;

export const InputSectionDescription = styled.div`
  margin-bottom: 8px;
  font-size: 12px;
  color: ${th('colors.pickledBluewood2')};
`;

export const InputSectionChildren = styled.div`
  @media ${sizes.largeDesktop} {
    width: 450px;
    flex-shrink: 0;
  }
`;

export const NameInputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media ${sizes.largeDesktop} {
    flex-direction: row;
  }
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
`;
